import PropTypes from 'prop-types'
import React from 'react'

const DurationToken = ({ duration, unit = 'hours' }) => {

  const formatDuration = () => {
    let result = ''
    let remaining = duration
    
    // Format based on unit type
    if (unit === 'hours') {
      // Format as XDXH
      if (remaining >= 24) {
        result += `${Math.floor(remaining / 24)}D `
        remaining %= 24
      }
      result += `${remaining}H`
    } 
    else if (unit === 'minutes') {
      // Format as XDXHXM
      const days = Math.floor(remaining / (24 * 60))
      remaining %= (24 * 60)
      
      const hours = Math.floor(remaining / 60)
      remaining %= 60
      
      if (days > 0) {
        result += `${days}D `
      }
      
      if (hours > 0 || days > 0) {
        result += `${hours}H `
      }
      
      result += `${remaining}M`
    } 
    else if (unit === 'seconds') {
      // Format as XDXHXMXS
      const days = Math.floor(remaining / (24 * 60 * 60))
      remaining %= (24 * 60 * 60)
      
      const hours = Math.floor(remaining / (60 * 60))
      remaining %= (60 * 60)
      
      const minutes = Math.floor(remaining / 60)
      remaining %= 60
      
      if (days > 0) {
        result += `${days}D `
      }
      
      if (hours > 0 || days > 0) {
        result += `${hours}H `
      }
      
      if (minutes > 0 || hours > 0 || days > 0) {
        result += `${minutes}M `
      }
      
      result += `${remaining}S`
    }
    
    return result
  }

  return (
    <div className="token">
      {formatDuration()}
    </div>
  )
}

DurationToken.propTypes = {
  duration: PropTypes.number.isRequired,
  unit: PropTypes.oneOf(['hours', 'minutes', 'seconds'])
}

export default DurationToken